import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />

      <main>
        <HeroSection />
        <CommentsSection />
        <IndexSection />
        <AppSection />
        <TopicsSection />
        <RankingSection />
        <FaqSection />
        <ContactSection />
        <FeaturesSection />
        <UpdatesSection />
        <CardsSection />
        <CarouselSection />
        <AboutSection />
        <MediaSection />
      </main>

      <Footer />
    </div>
  );
}